import React from 'react';
import { BenefitsListBlock } from 'patterns/BenefitsListBlock';
import { CardListBlock } from 'patterns/CardListBlock';
import { CTA } from 'patterns/CTA';
import { FAQListBlock } from 'patterns/FAQListBlock';
import { LogoListBlock } from 'patterns/LogoListBlock';
import { Masthead } from 'patterns/Masthead';
import { ServiceList } from 'patterns/ServiceList';
import { Shell } from 'patterns/Shell';
import { TestimonialListBlock } from 'patterns/TestimonialListBlock';

import '../scss/main.scss';

function ServicesPage({
    location: {
        pathname,
    },
}) {
    const data = {
        masthead: {
            title: 'What type of project do you need help with?',
            description: [
                {
                    spans: [],
                    text: 'I’ll work with you to create a new Jamstack marketing or eCommerce site that works towards your business goals.',
                    type: 'paragraph',
                },
            ],
        },
        services: {
            items: [
                {
                    service_button_text: {
                        text: 'Enquire about a Jamstack marketing site',
                    },
                    service_button_url: {
                        link_type: 'Document',
                        type: 'contact_page',
                        uid: 'contact',
                        url: '/contact',
                    },
                    service_check_item_1: {
                        text: 'Your current marketing website is outdated or isn’t meeting your business goals',
                    },
                    service_check_item_2: {
                        text: 'Your current marketing website is hard to manage, has security problems or is slow',
                    },
                    service_check_item_3: {
                        text: 'You need a new marketing website to promote your product or business to users, stakeholders or investors',
                    },
                    service_image: {
                        alt: '',
                        dimensions: {
                            height: 1288,
                            width: 1030,
                        },
                        url: 'https://images.prismic.io/robsimpson/9632055e-c1a5-4845-936f-a99be659879b_jamstack-markerting-site-large.png?auto=compress,format'
                    },
                    service_price: {
                        text: '£6,450',
                    },
                    service_service: {
                        text: 'Jamstack marketing site',
                    },
                    service_title: {
                        text: 'Jamstack marketing site',
                    },
                },
                {
                    service_button_text: {
                        text: 'Enquire about a Jamstack eCommerce site',
                    },
                    service_button_url: {
                        link_type: 'Document',
                        type: 'contact_page',
                        uid: 'contact',
                        url: '/contact',
                    },
                    service_check_item_1: {
                        text: 'Your current eCommerce website is outdated and needs a redesign',
                    },
                    service_check_item_2: {
                        text: 'Your current eCommerce website isn’t converting or meeting your business goals',
                    },
                    service_check_item_3: {
                        text: 'You need a new eCommerce website to sell your products online',
                    },
                    service_image: {
                        alt: '',
                        dimensions: {
                            height: 1288,
                            width: 1030,
                        },
                        url: 'https://images.prismic.io/robsimpson/bf1769a1-0be4-4917-bf71-ff351f59b6a3_jamstack-ecommerce-site-large.png?auto=compress,format'
                    },
                    service_price: {
                        text: '£14,950',
                    },
                    service_service: {
                        text: 'Jamstack eCommerce site',
                    },
                    service_title: {
                        text: 'Jamstack eCommerce site',
                    },
                },
            ],
        },
        benefits: {
            background: true,
            description: 'The Jamstack is a new way of building websites and apps. It does away with the database and leverages third-party services to create fast websites with higher security and a lower cost to scale – great for a business of any size.',
            items: [
                {
                    benefits_description: {
                        text: 'Why wait for pages to build on the fly when you can generate them ahead of time? Jamstack websites are up to 10 times faster than a traditional website',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/ea413853-4dda-44d0-9676-e67645fc968c_benefit-speed.png?auto=compress,format'
                    },
                    benefits_link_text: {
                        text: 'Link would go here',
                    },
                    benefits_link_url: {},
                    benefits_title: {
                        text: 'Speed',
                    },
                },
                {
                    benefits_description: {
                        text: 'Jamstack websites also gain better search rankings, which means more traffic and more revenue for your business',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/d64a7d79-c01c-4a64-8877-8e00935f5947_benefit-seo.png?auto=compress,format'
                    },
                    benefits_link_text: {
                        text: 'Link would go here',
                    },
                    benefits_link_url: {},
                    benefits_title: {
                        text: 'SEO',
                    },
                },
                {
                    benefits_description: {
                        text: 'No database, no plugins and a pre-built website means the surface area for attack is massively reduced which results in fewer security expenses',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/69bf2102-eb3a-480d-afeb-50958eb9b3f7_benefit-security.png?auto=compress,format'
                    },
                    benefits_link_text: {
                        text: 'Link would go here',
                    },
                    benefits_link_url: {},
                    benefits_title: {
                        text: 'Security',
                    },
                },
                {
                    benefits_description: {
                        text: 'Jamstack websites scale with your business and user base, meaning you only have to start paying more when your business and audience grow',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/050a6ab5-3d91-4d34-b8d7-bda55083536f_benefit-scalability.png?auto=compress,format'
                    },
                    benefits_link_text: {
                        text: 'Link would go here',
                    },
                    benefits_link_url: {},
                    benefits_title: {
                        text: 'Scalability',
                    },
                },
                {
                    benefits_description: {
                        text: 'The carbon footprint for a Jamstack website tends to be smaller than a traditional website as it is not connected to a server amongst other things',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/217fd148-1680-47e2-8170-31c723f6d5d1_benefit-sustainability.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Sustainability',
                    },
                },
            ],
            title: 'Benefits of the Jamstack',
        },
        design: {
            background: false,
            description: 'Design is more than just how something looks, a great looking design on its own will rarely give the outcome you’re after.',
            items: [
                {
                    card_description: {
                        text: 'Wireframes help to lay the foundation for your website. They put the focus on your goals, by getting the content, layout and hierarchy right.',
                    },
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 900,
                            width: 1200,
                        },
                        url: 'https://images.prismic.io/robsimpson/3f652434-afd3-4cd7-81b0-a913d61bf9cf_wireframes.png?auto=compress,format'
                    },
                    card_title: {
                        text: 'Wireframes',
                    },
                },
                {
                    card_description: {
                        text: 'Designs are then used to create a clickable prototype, so you can get a real feeling of how your website will work.',
                    },
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 1520,
                            width: 2027,
                        },
                        url: 'https://images.prismic.io/robsimpson/2319b718-bcf7-4d6a-b26a-2811eb8b80ea_interactive-prototype.png?auto=compress,format'
                    },
                    card_title: {
                        text: 'Interactive prototype',
                    },
                },
                {
                    card_description: {
                        text: 'Wireframes are then styled up to achieve the final look and feel. Designs are shared early and often so you aren’t left feeling blindsided.',
                    },
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 900,
                            width: 1200,
                        },
                        url: 'https://images.prismic.io/robsimpson/dfb635d3-3c8e-489e-855d-ab7e0579b08d_ui-design.png?auto=compress,format'
                    },
                    card_title: {
                        text: 'UI design',
                    },
                },
                {
                    card_description: {
                        text: 'A styleguide is put together to keep everything consistent as the project grows, plus making it easier for developers to get started.',
                    },
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 900,
                            width: 1200,
                        },
                        url: 'https://images.prismic.io/robsimpson/ee611090-0b78-4a82-b06c-ade0cc3f0ca7_design-system.png?auto=compress,format'
                    },
                    card_title: {
                        text: 'Styleguide',
                    },
                },
            ],
            itemsPerRow: '2',
            title: 'What goes into a design project?',
        },
        development: {
            description: 'A great website is the result of many different facets coming together – usually things you can’t see at first.',
            items: [
                {
                    benefits_description: {
                        text: 'Website performance can make or break a business nowadays – both users and search engines expect websites to be fast.',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/ea413853-4dda-44d0-9676-e67645fc968c_benefit-speed.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Performance',
                    },
                },
                {
                    benefits_description: {
                        text: 'SEO can be divided into two broad categories, technical and non-technical. How your site has been built will determine its technical SEO.',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/d64a7d79-c01c-4a64-8877-8e00935f5947_benefit-seo.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'SEO',
                    },
                },
                {
                    benefits_description: {
                        text: 'Animation is no longer a nice to have, when done right it has some real benefits when it comes to the user experience.',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/ecfbb491-30cb-41f9-a4c9-41bc4891c248_benefit-animation.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Animation',
                    },
                },
                {
                    benefits_description: {
                        text: 'Disabilities come in all shapes and sizes, having an inclusive website gives you an edge over your competitors.',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/522d8bc8-14d3-46ab-8234-39817e832328_benefit-accessibility.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Accessibility',
                    },
                },
                {
                    benefits_description: {
                        text: 'A pattern library is a collection of small, reusable UI components that are used to build up different pages on your website.',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/96c62882-19b4-4d97-8382-8f94458826a9_benefit-pattern-library.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Pattern library',
                    },
                },
                {
                    benefits_description: {
                        text: 'It’s easy to forget that digital projects play a role in climate change, but through proper optimisation, the effects can be reduced.',
                    },
                    benefits_image: {
                        alt: '',
                        dimensions: {
                            height: 160,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/217fd148-1680-47e2-8170-31c723f6d5d1_benefit-sustainability.png?auto=compress,format'
                    },
                    benefits_title: {
                        text: 'Sustainability',
                    },
                },
            ],
            itemsPerRow: 3,
            title: 'What goes into a development project?',
        },
        technologies: {
            background: false,
            description: 'Modern technologies I use to push your business forward.',
            items: [
                {
                    logo_image: {
                        alt: 'NextJS',
                        dimensions: {
                            height: 48,
                            width: 78,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/07d83a4e-32f1-42d5-994c-c655e6362bf4_NextJS.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://nextjs.org/',
                    },
                    logo_size: {
                        text: 'large',
                    },
                    logo_size_mobile: {
                        text: 'xlarge',
                    },
                },
                {
                    logo_image: {
                        alt: 'Gatsby',
                        dimensions: {
                            height: 40,
                            width: 153,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/aac70c63-d427-4889-9ded-6b4544629b09_Gatsby.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://www.gatsbyjs.com/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
                {
                    logo_image: {
                        alt: 'Prismic',
                        dimensions: {
                            height: 40,
                            width: 152,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/1416ec99-c8f0-415f-8832-05f6cd29f895_Prismic.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://prismic.io/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
                {
                    logo_image: {
                        alt: 'Shopify',
                        dimensions: {
                            height: 40,
                            width: 134,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/5485de44-da3f-4750-9e6c-2ec96de23f3c_Shopify.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://www.shopify.co.uk/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
                {
                    logo_image: {
                        alt: 'Vercel',
                        dimensions: {
                            height: 32,
                            width: 136,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/322cea98-fdd1-48bc-8115-536e3404e1e9_Vercel.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://vercel.com/',
                    },
                    logo_size: {
                        text: 'small',
                    },
                    logo_size_mobile: {
                        text: 'medium',
                    },
                },
                {
                    logo_image: {
                        alt: 'Netlify',
                        dimensions: {
                            height: 40,
                            width: 144,
                        },
                        url: 'https://robsimpson.cdn.prismic.io/robsimpson/e87e7934-70f9-47b6-b321-6a689a3780ae_Netlify.svg'
                    },
                    logo_link: {
                        link_type: 'Web',
                        url: 'https://www.netlify.com/',
                    },
                    logo_size: {
                        text: 'medium',
                    },
                    logo_size_mobile: {
                        text: 'large',
                    },
                },
            ],
            title: 'Technologies I use',
        },
        cta: {
            buttonText: 'Hire me',
            buttonUrl: {
                link_type: 'Document',
                type: 'contact_page',
                uid: 'contact',
                url: '/contact',
            },
            description: 'Let’s turn your website into a tool that’ll push your business forward.',
            title: 'Ready to take your business to the next level?',
        },
        faqs: {
            description: 'Have a question? I’m confident you’ll find the answer here, but if not please email hello@robsimpson.digital',
            items: [
                {
                    faq_question: {
                        text: 'What technologies do you use?',
                    },
                    faq_answer: {
                        text: 'My preferred technical stack is the JAMstack, I use technologies like Gatsby and Next as the framework for websites, coupled with a headless CMS like Prismic or Dato for the data layer and hook it up to Netlify or Vercel for hosting.',
                    },
                },
                {
                    faq_question: {
                        text: 'Will you code existing designs?',
                    },
                    faq_answer: {
                        text: 'Yes. I’m often approached by teams who’ve already designed a new website and are looking for a developer to bring it to life.',
                    },
                },
                {
                    faq_question: {
                        text: 'How much does a project cost?',
                    },
                    faq_answer: {
                        text: 'Pricing can vary greatly from project to project (based on the skills you require and your technical requirements). If you’re after a marketing site prices start from £6,450 and if you’re after an eCommerce site prices start at £14,950.',
                    },
                },
                {
                    faq_question: {
                        text: 'How long will my project take?',
                    },
                    faq_answer: {
                        text: 'A typical Jamstack website with 4-5 different templates usually takes between 4-8 weeks to design and build (with full CMS options). Assuming timely delivery of content, assets etc.',
                    },
                },
                {
                    faq_question: {
                        text: 'Do you do all the work yourself?',
                    },
                    faq_answer: {
                        text: 'Majority of the time yes. On the rare occasion that I might need some additional help on a project, I only ever work with Kev Simpson (my brother) who is a highly skilled front-end developer who I can trust to get the work done to that standard I’d expect.',
                    },
                },
                {
                    faq_question: {
                        text: 'How do payments work?',
                    },
                    faq_answer: {
                        text: 'I take 50% upfront (before any work begins) and 50% on completion (once design or development is complete). For bigger projects they’ll be billed 50% upfront and then 2 payments of 25% at agreed milestones.',
                    },
                },
                {
                    faq_question: {
                        text: 'When can you start my project?',
                    },
                    faq_answer: {
                        text: 'I rarely have immediate availability, I’m typically booked up for 1-2 months in advance. If you’re interested in working with me, please tell me about your project as soon as possible.',
                    },
                },
                {
                    faq_question: {
                        text: 'Do you provide ongoing support?',
                    },
                    faq_answer: {
                        text: 'Yes. Once your project is complete I offer ongoing support to my clients who need or want it. This is usually to add additional features as their business grows and changes over time.',
                    },
                },
            ],
            title: 'Frequently asked questions',
        },
        testimonials: {
            background: false,
            description: 'Hearing how happy my clients are is the best part of what I do.',
            items: [
                {
                    testimonial_bio: {
                        text: 'Co-Founder at Howl',
                    },
                    testimonial_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/c4375679-f583-43e4-812c-cb23c567318b_david-laub.png?auto=compress,format'
                    },
                    testimonial_quote: {
                        text: 'Rob has a unique ability to understand user experience needs, produce aesthetically pleasing designs, and write maintainable / modular code. To anyone in search of a highly creative and experienced developer for their next project - look no further.',
                    },
                    testimonial_name: {
                        text: 'David Laub',
                    },
                },
                {
                    testimonial_bio: {
                        text: 'Branding & Digital Designer',
                    },
                    testimonial_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/d7b9abda-bc6a-40f4-8b91-1a4278e3ea0f_david-sewell.png?auto=compress,format'
                    },
                    testimonial_quote: {
                        text: 'Rob really understood the value of a great user experience and looked at how page transitions could enhance this. Optimisation was also a key part of the build. By compressing content, minimising the amount of plug-ins used and cross device testing he was able to deliver a modern, unique and responsive website.',
                    },
                    testimonial_name: {
                        text: 'David Sewell',
                    },
                },
            ],
            itemsPerRow: '2',
            title: 'Client success stories',
        },
    };

    return (
        <Shell
            pageDescription="I’ll work with you to create a new Jamstack marketing or eCommerce website using technologies like Gatsby, NextJS, Prismic, DatoCMS and more."
            pageSocialImage=""
            pageTitle="Services"
            pathname={pathname}
        >
            <Masthead
                description={data.masthead.description}
                title={data.masthead.title}
            />
            <ServiceList
                items={data.services.items}
            />
            <BenefitsListBlock
                background={data.benefits.background}
                description={data.benefits.description}
                items={data.benefits.items}
                title={data.benefits.title}
            />
            <CardListBlock
                background={data.design.background}
                description={data.design.description}
                items={data.design.items}
                itemsPerRow={data.design.itemsPerRow}
                title={data.design.title}
            />
            <BenefitsListBlock
                background={data.development.background}
                description={data.development.description}
                items={data.development.items}
                itemsPerRow={data.development.itemsPerRow}
                title={data.development.title}
            />
            <LogoListBlock
                background={data.technologies.background}
                description={data.technologies.description}
                items={data.technologies.items}
                title={data.technologies.title}
            />
            <CTA
                buttonText={data.cta.buttonText}
                buttonUrl={data.cta.buttonUrl}
                description={data.cta.description}
                title={data.cta.title}
            />
            <FAQListBlock
                description={data.faqs.description}
                items={data.faqs.items}
                title={data.faqs.title}
            />
            <TestimonialListBlock
                background={data.testimonials.background}
                description={data.testimonials.description}
                items={data.testimonials.items}
                itemsPerRow={data.testimonials.itemsPerRow}
                title={data.testimonials.title}
            />
        </Shell>
    );
}

export default ServicesPage;
